import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
 
// const CountdownContainer = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: transparent;
//   z-index: 9999;
//   padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
// `;
 
const CountdownContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  z-index: 1000;
  /* 전체 영역에서 pointer 이벤트만 받도록 */
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
`;
 
const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
`;

const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const CountdownNumber = styled.div`
  font-size: 8rem;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
  animation: ${pulse} 1s ease-in-out;
  font-family: 'Arial', sans-serif;
  @media (max-width: 768px) {
    font-size: 6rem;
  }
`;
 
const TouchOverlay = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 2.2rem;
  font-weight: bold;
  text-align: center;
  user-select: none;
  z-index: 9999;
  padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  animation: ${blink} 2s ease-in-out infinite;
  font-family: 'Arial', sans-serif;
`;

const PlayButton = styled.div`
  background: var(--primary-gradient);
  border: none;
  border-radius: 50px;
  padding: 20px 40px;
  font-size: 2.2rem;
  font-weight: bold;
  color: white;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(255, 107, 107, 0.4);
  transition: all 0.3s ease;
  animation: ${blink} 2s ease-in-out infinite;
  user-select: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(255, 107, 107, 0.6);
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.5);
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
    padding: 18px 36px;
    border-radius: 45px;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
    padding: 15px 30px;
    border-radius: 40px;
  }
`;
 
// iOS 감지 함수
const isiOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
 
const Countdown = ({ onCountdownEnd, onPlayTouch, round }) => {
  const [mode, setMode] = useState('touch'); // 'touch' | 'countdown'
  const [count, setCount] = useState(3);
 
 
  useEffect(() => {
    if (mode !== 'countdown') return;
    if (count > 0) {
      const timer = setTimeout(() => setCount(c => c - 1), 1000);
      return () => clearTimeout(timer);
    }
    // count === 0
    setTimeout(onCountdownEnd, 500);
  }, [mode, count, onCountdownEnd]);
 
  const handlePlayTouch = async (e) => {
    //e.preventDefault();
    e.stopPropagation();
    try {
      // iOS에서 즉시 오디오 초기화 및 잠금 해제
      if (onPlayTouch) {
        await onPlayTouch();
      }
      
      // iOS에서는 약간의 지연 후 카운트다운 시작
      if (isiOS()) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      
      setMode('countdown');
    } catch (error) {
      console.warn('Touch handling error:', error);
      // 에러가 발생해도 카운트다운은 시작
      setMode('countdown');
    }
  };
 
  // iOS에서 여러 터치 이벤트 지원
  const handleTouchStart = (e) => {
    if (isiOS()) {
      handlePlayTouch(e);
    }
  };
 
  const handleClick = (e) => {
    if (!isiOS()) {
      handlePlayTouch(e);
    }
  };
 
  if (mode === 'touch') {
    return (
      <>
      <p style={{fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '0', marginTop: '50px', color: 'yellow', fontFamily: 'Arial, sans-serif'}}>ROUND {round} / 3</p> 
      <TouchOverlay
        onPointerDown={handlePlayTouch}
        onClick={handlePlayTouch}
        onTouchStart={handlePlayTouch}
      >
        TOUCH<br />and<br />PLAY
      </TouchOverlay>
      </>
    );
  }
  
  // mode가 'countdown'으로 바뀌면 숫자 표시
  return (
    <CountdownContainer>
      <CountdownNumber>{count}</CountdownNumber>
    </CountdownContainer>
  );
};
 
export default Countdown;